import './teachers.css'
import teacher1 from "../../Assets/images/teachers1.png"
import teacher2 from "../../Assets/images/teachers2.png"
import teacher3 from "../../Assets/images/teachers3.png"
import teacher4 from "../../Assets/images/teachers4.png"
import teacher5 from "../../Assets/images/teachers5.png"
import { Col, Container, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import headerImg from "../../Assets/images/Group 121.png"
import ProgramHighlights from '../programHighlights/ProgramHighlights'
import duration from "../../Assets/images/duration.png";
import format from "../../Assets/images/format.png";
import level from "../../Assets/images/levels.png";
import certification from "../../Assets/images/certification.png";
import WhatYouGetSection from '../whatYouGetSection/WhatYouGetSection'
import whatYouGetImg from "../../Assets/images/Frame 234.png";
import WhoThisProgramIsFor from '../WhoThisProgramIsFor/WhoThisProgramIsFor'
import img26 from "../../Assets/images/5.png";
import img27 from "../../Assets/images/3.png";
import img28 from "../../Assets/images/11.png";
import img29 from "../../Assets/images/4.png";
import img30 from "../../Assets/images/6.png";
import { useState } from 'react'
import { Modal } from 'antd'
import RegistrationPopup from '../registrationPopUp/RegistrationPopup'

const Teachers = () => {

  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);


  const cardsData = [
    { title: t("duration"), details: t("teacher_training_cardData.duration_details"), img: duration },
    { title: t("format"), details: t("teacher_training_cardData.format_details"), img: format },
    { title: t("level"), details: t("teacher_training_cardData.level_details"), img: level },
    { title: t("certification"), details: t("teacher_training_cardData.certification_details"), img: certification },
  ];

  const whatYouGetData = [
    { description: t("what_you_get_1") },
    { description: t("what_you_get_2") },
    { description: t("what_you_get_3") },
    { description: t("what_you_get_4") },
    { description: t("what_you_get_5") },
  ]

  const whatProgramFor = [
    { img: img26, title: t("aspiring_teachers"), desc: t("aspiring_teachers_desc") },
    { img: img27, title: t("current_arabic_instructors"), desc: t("current_arabic_instructors_desc") },
    { img: img28, title: t("educators_and_institutions"), desc: t("educators_and_institutions_desc") },
    { img: img29, title: t("parents_and_community_educators"), desc: t("parents_and_community_educators_desc") },
  ];
  return (
    <div className='teacher pt-5'>

      <section className='arabicLife-sec'>
        <div className='first-section position-relative'>
          <Row className='justify-content-start flex-column gx-0'>
            <Col md={12} className='content-box'>
              <Container>
                <h2 className='mb-3' style={{ marginTop: "150px" }}>{t("teacher_training_diploma")}</h2>
                <p className='mb-4'>
                  {t("teacher_training_diploma_desc")}
                </p>

              </Container>
            </Col>

          </Row>
          <Row className='justify-content-start flex-column '>
            <Col md={12} className='green-div'>
              <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                <Container>   <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>{t("start_now")}</button></Container>
              </div>


            </Col>

          </Row>
          <img src={headerImg} alt='' className='ar-life-logo' />
        </div>
      </section>

      <section>
        <Container>
          <ProgramHighlights cardsData={cardsData} color='#F3D7A559' />
          <WhatYouGetSection data={whatYouGetData} img={whatYouGetImg} />
        </Container>
      </section>

      <section className='my-5'>
        <WhoThisProgramIsFor data={whatProgramFor} />
      </section>

      <Container >
        <Row className=" no-gutters teacher-second-section">
          <Col md={6} sm={12}>
            <img src={teacher2} alt="teacher2" className=" w-100" />
          </Col>
          <Col md={6} sm={12}>
            <div>
              <h3 className="bold-font-style">
                {t("teachers_section.professional_dev_title")}
              </h3>
              <p className="normal-font-style mt-3">

                {t("teachers_section.professional_dev_desc")}
              </p>
            </div>
          </Col>
        </Row>

        <Row className="my-5 no-gutters teacher-third-section">

          <Col md={7} sm={12}>
            <div>
              <h3 className="custom-boldfont">
                {t("teachers_section.goal_title")}
              </h3>
              <p className="custom-normalfont mt-3">

                {t("teachers_section.goal_desc")}
              </p>
            </div>

            <div className='mt-5'>
              <h3 className="custom-boldfont">
                {t("teachers_section.competency_title")}
              </h3>
              <p className="custom-normalfont mt-3">
                {t("teachers_section.competency_desc")}
              </p>
            </div>
            <div className='mt-5'>
              <h3 className="custom-boldfont">
                {t("teachers_section.participation_title")}
              </h3>
              <p className="custom-normalfont mt-3">

                {t("teachers_section.participation_desc")}
              </p>
            </div>
          </Col>
          <Col md={5} sm={12}>
            <img src={teacher3} alt="teacher3" className="teacher-img w-100" />
          </Col>
        </Row>

        <Row className="mt-5 no-gutters teacher-forth-section">
          <Col md={7} sm={12}>
            <img src={teacher4} alt="teacher2" className="teacher-img w-100" />
          </Col>
          <Col md={5} sm={12}>
            <div className='forth-section-text'>
              <h3 className="bold-font-style">
                {t("teachers_section.growth_title")}
              </h3>
              <p className="normal-font-style mt-">

                {t("teachers_section.growth_desc")}
              </p>
            </div>
          </Col>
        </Row>

        <Row className="mt-5 no-gutters teacher-third-section pb-5 align-items-center">

          <Col md={7} sm={12}>
            <div className='mt-5'>
              <h3 className="custom-boldfont">
                {t("teachers_section.training_program_title")}
              </h3>
              <p className="custom-normalfont mt-3">
                {t("teachers_section.training_program_desc")}
              </p>
            </div>
            <button className='general-btn-style mt-3' onClick={() => setIsModalOpen(true)}>{t("teachers_section.enroll_now")}</button>
          </Col>
          <Col md={5} sm={12}>
            <img src={teacher5} alt="teacher3" className="teacher-img w-100" />
          </Col>
        </Row>
      </Container>
      <Modal
        open={isModalOpen}
        footer={null}
        destroyOnClose
        onCancel={() => setIsModalOpen(false)} // close handler
        width={"80vw"}

      >
        <RegistrationPopup setIsModalOpen={setIsModalOpen} />
      </Modal>
    </div>
  )
}

export default Teachers
